// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQPopup_container__1hMU0","body":"FAQPopup_body__11zXE"};